<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        xData: ["data1", "data2", "data3", "data4", "data5", "data6"],
        seriesData: [
          { value: 10, name: "制冷" },
          { value: 5, name: "供热" },
          { value: 15, name: "照明" },
          { value: 25, name: "电梯" },
          { value: 20, name: "空调" },
          { value: 35, name: "末端" },
          { value: 15, name: "其他" }
        ]
      },
      data: [
        [
          { value: 10, name: "制冷" },
          { value: 5, name: "供热" },
          { value: 15, name: "照明" },
          { value: 25, name: "电梯" },
          { value: 20, name: "空调" },
          { value: 35, name: "末端" },
          { value: 15, name: "其他" }
        ],
        [
          { value: 16, name: "制冷" },
          { value: 15, name: "供热" },
          { value: 25, name: "照明" },
          { value: 25, name: "电梯" },
          { value: 30, name: "空调" },
          { value: 15, name: "末端" },
          { value: 25, name: "其他" }
        ],
        [
          { value: 14, name: "制冷" },
          { value: 7, name: "供热" },
          { value: 7, name: "照明" },
          { value: 15, name: "电梯" },
          { value: 21, name: "空调" },
          { value: 23, name: "末端" },
          { value: 10, name: "其他" }
        ],
      ]
    }
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'power 左下'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.seriesData = this.data[index]

      index ++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>